import { ExperimentGroupingStatus } from '../../types/emsData'

export interface ExpFilterState {
    name: string
    domain: string
    status: ExperimentGroupingStatus
    startDateTime: Date | null
    endDateTime: Date | null
    page: number
    pageSize: number
}

export type FilterAction =
    | { type: 'SET_EXP_NAME'; payload: string }
    | { type: 'SET_DOMAIN'; payload: string }
    | { type: 'SET_STATUS'; payload: ExperimentGroupingStatus }
    | { type: 'SET_START_DATE_TIME'; payload: Date }
    | { type: 'SET_END_DATE_TIME'; payload: Date }
    | { type: 'SET_PAGE'; payload: number }
    | { type: 'SET_PAGE_SIZE'; payload: number }
    | {
          type: 'SET_PAGINATION'
          payload: {
              page: number
              pageSize: number
          }
      }
    | { type: 'SET_ALL_FILTERS'; payload: ExpFilterState }

export const init = (state: ExpFilterState) => state

export enum filterActionTypes {
    setName = 'SET_EXP_NAME',
    setDomain = 'SET_DOMAIN',
    setStatus = 'SET_STATUS',
    setStartDateTime = 'SET_START_DATE_TIME',
    setEndDateTime = 'SET_END_DATE_TIME',
    setPage = 'SET_PAGE',
    setPageSize = 'SET_PAGE_SIZE',
    setPagination = 'SET_PAGINATION',
    setAllFilters = 'SET_ALL_FILTERS',
}

const expFiltersReducer = (state: ExpFilterState, action: FilterAction): ExpFilterState => {
    switch (action.type) {
        case filterActionTypes.setName: {
            return { ...state, name: action.payload }
        }
        case filterActionTypes.setDomain: {
            return { ...state, domain: action.payload }
        }
        case filterActionTypes.setStatus: {
            return { ...state, status: action.payload }
        }
        case filterActionTypes.setStartDateTime: {
            return { ...state, startDateTime: action.payload }
        }
        case filterActionTypes.setEndDateTime: {
            return { ...state, endDateTime: action.payload }
        }

        case filterActionTypes.setPagination: {
            return { ...state, page: action.payload.page, pageSize: action.payload.pageSize }
        }
        case filterActionTypes.setPage: {
            return { ...state, page: action.payload }
        }
        case filterActionTypes.setPageSize: {
            return { ...state, pageSize: action.payload }
        }
        case filterActionTypes.setAllFilters: {
            return { ...action.payload }
        }
        default: {
            throw Error('Unknown action: ' + action.type)
        }
    }
}

export default expFiltersReducer

export const initialExpFilteringState: ExpFilterState = {
    name: '',
    domain: '',
    status: ExperimentGroupingStatus.ANY,
    startDateTime: null,
    endDateTime: null,
    page: 0,
    pageSize: 10,
}
